import React from "react"
import { Box } from "@mui/material"
import { AppRetailerBlockContainer } from "@components/DataBlocks"

export default function sitesColumn() {
	return [{
		name: "sitesNameFilter", label: "Sites",
		options: { display: 'excluded' }
	}, {
		name: "sitesName", label: "Sites",
		options: {
			headerAlign: 'left',
			filter: false,
			customBodyRowRenderLite: value => {
				return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: "center", gap: 0 }}>
					<AppRetailerBlockContainer rows={value}/>
				</Box>
			}
		}
	}]
}